import Vue from 'vue';
import Router from 'vue-router';
import HelloWorld from '@/components/HelloWorld';
import Home from '@/components/Home';

Vue.use(Router);

function currentSessionYear() {
  let d = new Date();
  let y = d.getFullYear();
  if (d.getMonth() >= 9) return 1 + y;
  return y;
}

export default new Router({
  routes: [
    // {
    //   path: '/',
    //   name: 'HelloWorld',
    //   component: HelloWorld,
    // },
    {
      path: '/',
      redirect: `/${currentSessionYear()}`
    },
    {
      path: '/:year',
      name: 'Home',
      component: Home,
    },
  ],
});



// WEBPACK FOOTER //
// ./src/router/index.js